export default __webpack_public_path__ + "static/Banners_a1-ac9a02b36895158bde96f8e497b69ef3.jpg";